import { $httpPhoenix, $httpChangiRecommends } from './api';
export const getAccountDetails = async () => {
    let accountDetailsResp = await $httpChangiRecommends.api.getUserData();
    if (!accountDetailsResp.data.data) {
        accountDetailsResp = await $httpChangiRecommends.api.getUserData();
        if (!accountDetailsResp.data.data) {
            accountDetailsResp = await $httpChangiRecommends.api.getUserData();
        }
    }
    return accountDetailsResp.data.data;
};
export const updateAccountDetails = async (accountDetails) => {
    const updateAccountDetailsResp = await $httpChangiRecommends.api.updateUserData(accountDetails);
    if (!updateAccountDetailsResp.data.data) {
        return {};
    }
    return updateAccountDetailsResp.data.data;
};
export const createUserAddress = async (userAddress) => {
    const createUserAddressResp = await $httpChangiRecommends.api.createUserAddress(userAddress);
    if (!createUserAddressResp.data.data) {
        return {};
    }
    return createUserAddressResp.data.data;
};
export const updateUserAddress = async (userAddressId, userAddress) => {
    const updateUserAddressResp = await $httpChangiRecommends.api.updateUserAddress(userAddressId, userAddress);
    return updateUserAddressResp.data;
};
export const deleteUserAddress = async (userAddressId) => {
    const deleteUserAddressResp = await $httpChangiRecommends.api.deleteUserAddress(userAddressId);
    return deleteUserAddressResp.data;
};
export const setUserAddressAsDefault = async (userAddressId) => {
    const setUserAddressAsDefaultResp = await $httpChangiRecommends.api.setUserAddressAsDefault(userAddressId);
    return setUserAddressAsDefaultResp.data;
};
export const getCountries = async () => {
    const getCountriesResp = await $httpPhoenix.api.countries();
    return getCountriesResp.data;
};
export const changePassword = async (userPassword) => {
    const changePasswordResp = await $httpChangiRecommends.api.changePassword(userPassword);
    return changePasswordResp.data;
};
